/**
* Video Class
*
* This class controls videos uploaded or embedded on the site
*
* @package  Manco Automatics
* @author   Tom Kellock
* @access   public
*/
class Video
{
  /**
  * Constructor function
  *
  * Function that performs actions upon initiation of this class
  *
  * @param    array  video   The video element
  * @return   void
  * @access   public
  */
  constructor(videos)
  {
    videos.forEach((video) => {
      this.videoBlock = video;
      this.thumbnail  = this.videoBlock.querySelector('.video__thumbnail');
      this.playButton = this.videoBlock.querySelector('.video__play');

      if (this.videoBlock.classList.contains('video--external')) {
        this.source = 'external';
        this.video  = this.videoBlock.querySelector('.video__iframe');
      } else if (this.videoBlock.classList.contains('video--library')) {
        this.source = 'library';
        this.video  = this.videoBlock.querySelector('.video__player');
      }

      this.playButton.addEventListener('click', () => {
        this._play();
      });
    });
  }

  _play()
  {
    if (this.source == 'external') {
      this.video.src = this.video.dataset.src;
    } else if (this.source == 'library') {
      this.video.play();
      this.video.setAttribute('controls', true);
    }

    this.videoBlock.classList.add('video--active');
  }
}

export default Video;
